export const PAYOUTS_ALL = 'payoutsAll';
export const PAYOUTS_ONE_TIME = 'payoutsOneTime';
export const PAYOUTS_OVER_TIME = 'payoutsOverTime';
